import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { PublicPageSettings } from 'src/app/models/preference-settings';
import { RootStoreState } from 'src/app/root-store/';
import { PreferencesSelectors } from 'src/app/root-store/preferences-store/';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { BaseComponent } from 'src/app/shared/base-components/base-component';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, RouterModule, AlertComponent, MatCardModule, MatProgressSpinnerModule, TranslatePipe],
})
export class LogoutComponent extends BaseComponent implements OnInit {
  publicPageSettings: PublicPageSettings;
  headerImage: string;

  constructor(
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private store: Store<RootStoreState.State>,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    // this.store.dispatch(AuthStoreAction.logout());
    this.subscribe(
      this.store.pipe(select(PreferencesSelectors.selectPreferencesPublicPageSettings)),
      (publicSettings) => (this.publicPageSettings = publicSettings),
    );
    this.subscribe(
      this.store.pipe(select(PreferencesSelectors.selectPreferencesLoginImage)),
      (headerImage) => (this.headerImage = headerImage),
    );
  }

  // Call this method in the image source, it will sanitize it.
  transform(base64Image: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64Image);
  }
}
